import { render, staticRenderFns } from "./jdgllist.vue?vue&type=template&id=63dc1004"
import script from "./jdgllist.vue?vue&type=script&lang=js"
export * from "./jdgllist.vue?vue&type=script&lang=js"
import style0 from "./jdgllist.vue?vue&type=style&index=0&id=63dc1004&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports